<template>
    <FAQ :tab="3"></FAQ>
</template>


<script>
import FAQ from '../users/FAQ.vue';

export default {
    name: "FAQWorkPlan",
    components: {
        FAQ,
    },
    data: function () {
        return {
        };
    },
    computed: {
    },
    methods: {
    },
};
</script>


<style lang="scss" scoped>
</style>
